import { useIsFastConfigurationContext } from "../IsFastConfigurationContext/IsFastConfigurationContext";

import type { JSX } from "react";

import {
  Substructure,
  SubstructureLayoutProps,
} from "@plansoft-configuration-renderer/components";
import { LayoutPreselectContext } from "@plansoft-configuration-renderer/layout";

import { CustomSubstructure } from "@/renderer/controls/CustomSubstructure/CustomSubstructure";

export function SubstructureMapper(
  props: Partial<SubstructureLayoutProps>,
): JSX.Element {
  const { isFastConfiguration } = useIsFastConfigurationContext();
  //overrides only the substructure with renderContentAsStandalone and keeps the default behavior for the rest
  if (props.custom?.renderContentAsStandalone) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isFastConfigurationURL = urlParams.get("schnellkonfigurator");

    const isFastConfigurationEffective =
      isFastConfiguration || isFastConfigurationURL === "true";

    const mapping = {
      CFG_GERAETETRAEGER: isFastConfigurationEffective
        ? "CFG_GERAETETRAEGER_SCHNELL"
        : "CFG_GERAETETRAEGER",
      CFG_TRAGSCHIENE: isFastConfigurationEffective
        ? "CFG_TRAGSCHIENE_SCHNELL"
        : "CFG_TRAGSCHIENE",
    };

    return (
      <LayoutPreselectContext.Provider value={mapping}>
        <CustomSubstructure />
      </LayoutPreselectContext.Provider>
    );
  }
  return <Substructure {...props} />;
}

SubstructureMapper.displayName = "SubstructureMapper";
